import React from"react";export const ManifestLink=({manifestUrl:e="/manifest.webmanifest"})=>React.createElement("link",{rel:"manifest",href:e});